import React, {useState, useContext, useEffect, useMemo, useRef} from "react";
import {Backdrop, Button, Card, CardActions, CardContent, Grid, ListItem} from "@material-ui/core";
import {useLocation} from "react-router-dom";
import {
  apollo_useStyles,
  CAMPAIGN_GOAL_NUMBER,
  Option, 
  options_age,
  options_area_pref,
  options_state,
  options_state_edit,
  options_zeus_billing_type,
  options_zeus_campaign_type,
  options_zeus_pmp_type,
  valueToOptionNull,
  ZEUS_BILLING_TYPE,
  ZEUS_DELIVERY_TYPE,
  ZEUS_PMP_TYPE
} from "../../../atom/Apollo_styles";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {ApolloAxios, ApiResponse, isSuccessApi, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {ApolloLabel} from "../../../atom/Apollo_Label";
import {
  ApolloBasicLabel,
  ApolloBasicSelect,
  ApolloBasicTextField,
  ApolloCustomTextField
} from "../../../molecule/Apollo_BaseItem";
import {
  hera_audiences_path,
  get_zeus_campaign_path, 
  hera_account_path,
  list_poseidon_availabletarget_path,
  list_poseidon_availableaffinity_path,
  get_zeus_placement_settings_path,
} from "../../../atom/Apollo_links";

import {
  Audience,
  Campaign,
  OsType,
} from "./AdGroupModelZeus";
import {
  AdGroupZeus
} from "./AdGroupModelZeus";
import {useForm, Controller} from "react-hook-form";
import {checkInvalidCharForName} from "../../../common/Apollo_CommonUtil";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import axios from "axios";
import {ErrorMessage} from "@hookform/error-message";
import {FormControl, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse/Collapse";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import {
  APOLLO_GROUP_OPERATOR,
  APOLLO_SYSTEM_ADMIN,
  ApolloUserProfileAuth, getEditPermission,
} from "../../../atom/Apollo_Authorization";
import {
  AFFINITY_CATEGORY_MAX_ZEUS,
  RETARGETING_MAX_ZEUS,
  TARGET_TYPE,
  options_zeus_ad_target,
} from "./common/CommonConst"
import {Bars} from "react-loader-spinner";
import {MenuPlacement} from "react-select/src/types";
import {CampaignZeus} from "../../CAMPAIGN/zeus/CampaignModelZeus";
import { ResAvailableTarget } from "../../SEGMENT/poseidon/SegmentModel";
import { ResAvailableAffinityCategory } from "../../SEGMENT/poseidon/AffinityCategoryModel";
import { ResPlacementSetting } from "./AdGroupModelZeus";
import { optionPlacementSetting } from "./AdGroupModelZeus";

const animatedComponents = makeAnimated();

export const BLANK = ""

type ZeusAdGroupFormProps = {
  platformAccountId: number,
  adGroupId: number,
  adGroupState: {
    adGroup: AdGroupZeus,
    setAdGroup: any,
    osType: OsType,
    setOsType: any,
    cpcLimitOver: boolean,
    setCpcLimitOver: any,
    isCpcLimitDisabled: boolean,
    setIsCpcLimitDisabled: any,
    errors: any,
    setError: any,
  },
  demograStatus: {
    ageMin: number|null,
    setAgeMin: any,
    ageMax: number|null,
    setAgeMax: any,
    gender1: boolean,
    setGender1: any,
    gender2: boolean,
    setGender2: any,
    gender3: boolean,
    setGender3: any,
    checkedPref: boolean[],
    setCheckedPref:any,
    prefRenderId: number,
    setPrefRenderId:any
  },
  hasAd: boolean,
  submitAction: any,
  goBackAction: any,
}

export type CampaignsSh = {
  network: OptionCampaign[],
  pmp: OptionCampaign[],
  reserve: OptionCampaign[],
}

export type OptionCampaign = {
  value: number,
  label: string,
  autoBidding: boolean,
  excludingAudiences: number[],
  campaignGoal: number,
  deliveryType: number,
  pmpType: number | null,
}

const initCampaign: Campaign = {
  name: "",
  autoBidding: false,
  excludingAudiences: [],
  deliveryType: 0,
  pmpType: null,
}

const initPlacement: ResPlacementSetting = {
  id: 0,
  createdAt: "",
  updatedAt: "",
  placementId: 0,
  placementName: "",
  pmpType: 0,
  dealIdSetting: "",
  billingType: 0,
  lowerLimitPayment: 0,
  lowerLimitCharge: 0,
  publicStatus: 0,
  displayStatus: 0,
  adAccountIds: []
}

const RESERVE_CPC_MAX = 9999999999;
const CPM_LIMIT_MAX = 9999999999;

export const valueToZeusCampaignNull = function (value: any, options: OptionCampaign[]): OptionCampaign | null {
  let option = options.find(option => option.value === value);
  if (!option) {
    return null;
  } else {
    return option;
  }
}


const isValid = function (adGroupId: number, adGroup: AdGroupZeus): boolean {
  if (adGroup.name === "") return false;
  if (adGroup.adCampaignId === 0) return false;
  if (adGroup.deliveryType == ZEUS_DELIVERY_TYPE.DSP && adGroup.pmpType !== ZEUS_PMP_TYPE.OPEN_AUCTION && adGroup.placementSettingId == null) return false;
  return true;
}

// 画面名：広告グループ作成（Zeus）
const AdGroupFormZeus = ({
                         platformAccountId,
                         adGroupId,
                         adGroupState,
                         demograStatus,
                         hasAd,
                         submitAction,
                         goBackAction,
                       }: ZeusAdGroupFormProps) => {
  const classes = apollo_useStyles();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {control, errors, formState, handleSubmit, register} = useForm({mode: "onBlur", reValidateMode: "onBlur"});

  const [campaigns, setCampaigns] = useState<OptionCampaign[]>([]);
  const trackerId = state.current.trackerId;
  const isEditor = getEditPermission(state);
  const [optionAudiences, setOptionAudiences] = useState<Option[]>([]);
  const [audiences, setAudiences] = useState<Option[]>([]);
  const [deletedAudiences, setDeletedAudiences] = useState<Option[]>([]);
  const [optionTargets, setOptionTargets] = useState<Option[]>([]);
  const [optionAffinityCategories, setOptionAffinityCategories] = useState<Option[]>([]);
  const [optionCustomSegments, setOptionCustomSegments] = useState<Option[]>([]);
  const [optionPlacementSettings, setOptionPlacementSettings] = useState<optionPlacementSetting[]>([]);
  const [placement, setInitPlacement] = useState<ResPlacementSetting[]>([]);
  const [lowerLimitCharge, setLowerLimitCharge] = useState<number | undefined>(0);
  const [warningMessage, setWarningMessage] = useState<string | null>(null);
  const [checkedArea, setCheckedArea] = useState([false, false, false, false, false, false, false, ])

  const [progress, setProgress] = useState(true);
  const processing = useRef(false);
  // const [prefRenderId, setPrefRenderId] = useState(0);
  const [openDemogra, setOpenDemogra] = useState(false);
  // const [osType, setOsType] = useState<number>(1);
  const [campaign, setCampaign] = useState<Campaign>(initCampaign);
  // const [excludingAudienceIds, setExcludingAudienceIds] = useState<number[]>([]);
  // const [campaignGoal, setCampaignGoal] = useState<number>(-1)
  const [initStatus] = useState<number>(adGroupState.adGroup.status)

  let query1 = new URLSearchParams(useLocation().search);
  let queryType = query1.has("type") ? query1.get("type") : "cp";

  const handleChangeOsType = (event: any) => {
    const localOsType: OsType = {
      ...adGroupState.osType,
      [event.target.name]: event.target.checked,
    }
    if (!localOsType.pc && !localOsType.ios && !localOsType.android) return;

    adGroupState.setOsType({
      ...localOsType,
    })
  }

  const onSubmit = handleSubmit(async () => {
    if (processing.current) return;
    if (formState.isSubmitting) return;
    processing.current = true;
    await submitAction(optionAudiences, optionAffinityCategories, optionCustomSegments, optionPlacementSettings);
    processing.current = false;
    setProgress(false);
  });

  const stringToBoolean = (value: string | null | undefined) => {
    // null、undefined は false
    if (!value) {
        return false;
    }
    return value.toLowerCase() === 'true' || value === '1';
  }

  const createValIsCpcLimitDisabled = (adCampaignId: number): boolean => {
    const autoBidding = valueToZeusCampaignNull(adCampaignId, campaigns)?.autoBidding ?? false;
    const isDisabled = autoBidding === true;
    return isDisabled;
  }

  const createOptionsTargetingType = (deliveryType: number, adCampaignId: number, pmpType: number | null): Option[] => {
    const localValCampaignGoal = valueToZeusCampaignNull(adCampaignId, campaigns)?.campaignGoal ?? -1;
    const options: Option[] = []
    if (adCampaignId == 0) {
      options.push(options_zeus_ad_target[0]);
      options.push(options_zeus_ad_target[1]);
      options.push(options_zeus_ad_target[2]);
      options.push(options_zeus_ad_target[3]);
      options.push(options_zeus_ad_target[4]);
    } else if (deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE) {
      switch (localValCampaignGoal) {
        case CAMPAIGN_GOAL_NUMBER.TARGET:
          options.push(options_zeus_ad_target[0]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
          break;
        case CAMPAIGN_GOAL_NUMBER.CLICK:
          options.push(options_zeus_ad_target[1]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
          break;
        case CAMPAIGN_GOAL_NUMBER.CV:
        case CAMPAIGN_GOAL_NUMBER.CPA:
          options.push(options_zeus_ad_target[1]);
          break;
        default:
          options.push(options_zeus_ad_target[0]);
          options.push(options_zeus_ad_target[1]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
          break;
      }
    } else if (deliveryType === ZEUS_DELIVERY_TYPE.DSP) {
      if (localValCampaignGoal == CAMPAIGN_GOAL_NUMBER.CV && pmpType == ZEUS_PMP_TYPE.OPEN_AUCTION) {
          options.push(options_zeus_ad_target[1]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
      } else if (localValCampaignGoal == CAMPAIGN_GOAL_NUMBER.CV && pmpType == ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION) {
          options.push(options_zeus_ad_target[0]);
          options.push(options_zeus_ad_target[1]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
      } else if (localValCampaignGoal == CAMPAIGN_GOAL_NUMBER.TARGET && pmpType == ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION) {
          options.push(options_zeus_ad_target[0]);
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
      } else {
          options.push(options_zeus_ad_target[2]);
          options.push(options_zeus_ad_target[3]);
          options.push(options_zeus_ad_target[4]);
      }
    }
    return options
  }

  /** （新規作成画面）キャンペーン情報によって各種項目の初期値が変わるため、ここで変更する */
  const changeInputFormData = (currentData: AdGroupZeus): AdGroupZeus => {
    if (adGroupId !== 0) return currentData;

    const deliveryType = currentData.deliveryType;
    const adCampaignId = currentData.adCampaignId;
    const optionsTargetingType: Option[] = createOptionsTargetingType(deliveryType, adCampaignId, currentData.pmpType)
    const isCpcLimitDisabled = createValIsCpcLimitDisabled(adCampaignId);

    let billingType = currentData.billingType;
    let cpcLimit = currentData.cpcLimit
    let cpmLimit = currentData.cpmLimit
    let pmpType = currentData.pmpType
    let autoBidding = valueToZeusCampaignNull(adCampaignId, campaigns)?.autoBidding ?? true;

    switch(deliveryType) {
      case ZEUS_DELIVERY_TYPE.PERFORMANCE:
        billingType = ZEUS_BILLING_TYPE.CPC_CPM
        if (isCpcLimitDisabled) cpcLimit = 1
        cpmLimit = 1
        adGroupState.setOsType({...adGroupState.osType, pc: true})
        if (autoBidding) adGroupState.setCpcLimitOver(true)
        break;
      case ZEUS_DELIVERY_TYPE.DSP:
        billingType = ZEUS_BILLING_TYPE.CPM
        cpcLimit = 1
        adGroupState.setOsType({...adGroupState.osType, pc: false})
        if (autoBidding)  { 
          adGroupState.setCpcLimitOver(true)
        } else {
          adGroupState.setCpcLimitOver(false)
        }
        break;
    }

    let ret: AdGroupZeus = {
      ...currentData,
      billingType: billingType,
      cpcLimit: cpcLimit,
      cpmLimit: cpmLimit,
      targetingType: optionsTargetingType[0].value,
      pmpType: pmpType === undefined ? null : pmpType,
    };

    return ret;
  }

  useEffect(() => {
    setLowerLimitCharge(placement.find((res) => res.id === adGroupState.adGroup.placementSettingId)?.lowerLimitCharge)
  })

  useEffect(() => {
    const optionsTargetingType: Option[] = createOptionsTargetingType(adGroupState.adGroup.deliveryType, adGroupState.adGroup.adCampaignId, adGroupState.adGroup.pmpType)
    setOptionTargets(optionsTargetingType);
    const isDisabled = createValIsCpcLimitDisabled(adGroupState.adGroup.adCampaignId);
    adGroupState.setIsCpcLimitDisabled(isDisabled);

    if (isDisabled) {
      let localValCpcLimitOver = adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? true : adGroupState.cpcLimitOver
      adGroupState.setCpcLimitOver(localValCpcLimitOver)
    }
  }, [campaigns, adGroupState.adGroup.deliveryType, adGroupState.adGroup.adCampaignId]);

  useEffect(() => {
    if (adGroupState.adGroup.id === 0) {
      if(audiences.length > 0) setOptionAudiences(audiences);
      return;
    }

    if (adGroupState.adGroup.targetingType === TARGET_TYPE.RETARGET) {
      const deletedList: Option[] = [];
      adGroupState.adGroup.retargetingIds?.map((id) => {
        const option = valueToOptionNull(id, deletedAudiences);
        if(option) {
          deletedList.push(option);
        }
      });
      const mixList = audiences.concat(deletedList);
      setOptionAudiences(mixList);
    }
  }, [audiences, deletedAudiences, adGroupState.adGroup.id]);

  useEffect(() => {
    // キャンペーン情報取得処理
    // 更新画面のほか、新規作成画面でもキャンペーン一覧からドリルダウンで遷移してきた際にこの処理が必要
    if (adGroupState.adGroup.adCampaignId === 0) return;
    if (campaigns.length === 0) return;

    const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_campaign_path + "/" + adGroupState.adGroup.adCampaignId.toString()
    axios.get(url,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
      }).then((response) => {
      if (response.data) {
        const result: CampaignZeus = response.data
        setCampaign({
          name: result.name,
          autoBidding: result.autoBidding,
          excludingAudiences: result.excludingAudiences,
          deliveryType: result.deliveryType,
          pmpType: result.pmpType ?? null
        });
        const inputData = changeInputFormData({
          ...adGroupState.adGroup,
          deliveryType: result.deliveryType,
          billingType: result.billingType,
          adCampaignName: result.name,
          pmpType: result.pmpType ?? null
        })
        adGroupState.setAdGroup(inputData);
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "Zeusキャンペーン情報の取得に失敗しました"
        }
      });
    });
  }, [campaigns, adGroupState.adGroup.adCampaignId]);

  useEffect(() => {

    const fetchCampaigns = async () => {
      // キャンペーン一覧情報取得
      const url = `${get_zeus_campaign_path}?account_id=${platformAccountId}&per_page=9999&page=1&sort=created&direction=desc`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "キャンペーン情報を取得できませんでした",
          });
        }
        const result: CampaignZeus[] = response.data ?? []

        const campaigns: OptionCampaign[] = [];
        result.map((data: CampaignZeus) => {
          if (data.status === 3) return;

          const option: OptionCampaign = {
            value: data.id,
            label: `${data.id}_${data.name}`,
            autoBidding: data.autoBidding,
            excludingAudiences: data.excludingAudiences?? [],
            campaignGoal: data.campaignGoal,
            deliveryType: data.deliveryType,
            pmpType: data.pmpType ?? null,
          }
          campaigns.push(option);
        });
        setCampaigns(campaigns);
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      });
    }

    const fetchAffinity = async () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${list_poseidon_availableaffinity_path}`
      await ApolloAxios.get(url).then(response => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `アフィニティリスト情報のデータ取得に失敗しました。${res?.message ?? BLANK}`
            }
          });
          return;
        }
        const result: ResAvailableAffinityCategory[] = res.result ?? []
        setOptionAffinityCategories(result.map((target: ResAvailableAffinityCategory) => (
          {value: target.id, label: `${target.id}_${target.name}`}
        )));
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `アフィニティリスト情報のデータ取得に失敗しました。${err?.errmsg ?? BLANK}`
          }
        });
      });
    }

    const fetchCustomInfo = async () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${list_poseidon_availabletarget_path}${state.current.accountGroupId}/${state.current.accountId}`
      await ApolloAxios.get(url).then(response => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `カスタムリスト情報のデータ取得に失敗しました。${res?.message ?? BLANK}`
            }
          });
          return;
        }
        const result: ResAvailableTarget[] = res.result ?? []
        result.sort((a, b) => b.id - a.id);
        setOptionCustomSegments(result.map((target: ResAvailableTarget) => (
          {value: target.id, label: `${target.id}_${target.name}`}
        )));
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `カスタムリスト情報のデータ取得に失敗しました。${err?.errmsg ?? BLANK}`
          }
        });
      });
    }

    const fetchAudiences = async () => {
      // トラッカーIDが無い場合
      if (!trackerId) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "広告グループの作成・編集に必要なオーディエンス情報が取得できませんでした。広告主アカウント詳細画面でトラッカーIDを確認して下さい。"
          }
        });
        return;
      }

      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "オーディエンス情報を取得できませんでした",
          });
        }

        const newTmpAudiences: Option[] = [];
        const result: Audience[] = response?.data?.result ?? []
        result.map(data => {
          const option: Option = {
            value: data.ID,
            label: data.isActive ? `${data.ID}_${data.name}` : `${data.ID}_${data.name}（停止中）`,
          }
          newTmpAudiences.push(option);
        });
        setAudiences(newTmpAudiences);

      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    // Hera情報等取得
    const fetchDeletedAudiences = async () => {
      // トラッカーIDが無い場合
      if (!trackerId) return;
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${state.current.accountId}/audiences/deleted`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "オーディエンス情報を取得できませんでした",
          });
        }

        const newDeletedAudiences: Option[] = [];
        response.data?.result?.map(function (data: { ID: number, name: string }) {
          const option: Option = {
            value: data.ID,
            label: `${data.ID}_${data.name}（削除済み）`,
          }
          newDeletedAudiences.push(option);
        });
        setDeletedAudiences(newDeletedAudiences);
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    const fetchPlacement = async () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_placement_settings_path}`
      await ApolloAxios.get(url).then(response => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `プレースメント情報のデータ取得に失敗しました。${res?.message ?? BLANK}`
            }
          });
          return;
        }

        const result: ResPlacementSetting[] = res.result ?? []
        const filteredResult = result.filter(target => 
          target.publicStatus === 1 && (
            target.displayStatus === 1 ||
            (target.displayStatus === 2 && !target.adAccountIds.includes(platformAccountId)) ||
            (target.displayStatus === 3 && target.adAccountIds.includes(platformAccountId))
          )
        );
        filteredResult.sort((a, b) => b.id - a.id);
        setOptionPlacementSettings(filteredResult.map((target: ResPlacementSetting) => (
          {value: target.id, label: `${target.placementName}`, pmpType: target.pmpType}
        )));
        setInitPlacement(result)
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `プレースメント情報のデータ取得に失敗しました。${err?.errmsg ?? BLANK}`
          }
        });
      });
    }


    const fetchAll = async () => {
      processing.current = true;
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      });

      await Promise.all(
        [fetchCampaigns(), fetchAffinity(), fetchCustomInfo(), fetchAudiences(), fetchDeletedAudiences(), fetchPlacement()]
      ).finally(() => {
        processing.current = false;
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setProgress(false)
      });
    }
    fetchAll();
  }, []);

  const displayWarningMessage = () => {
    if (adGroupState.adGroup.pmpType !== ZEUS_PMP_TYPE.OPEN_AUCTION) {
      if (adGroupState.adGroup.cpmLimit==null? 0 : adGroupState.adGroup.cpmLimit == 0) {
        return "必須入力項目です。"
      } else if (adGroupState.adGroup.cpmLimit==null? 0 :adGroupState.adGroup.cpmLimit < (lowerLimitCharge ?? 1)) {
        return "⚠現在の金額で設定は可能ですが、" + lowerLimitCharge + "以上の上限CPMを設定することをおすすめします。"
      } else {
        return ""
      }
    } else {
      if (adGroupState.adGroup.cpmLimit==null? 0 : adGroupState.adGroup.cpmLimit < 1) {
        return "1以上を入力してください。"
      } else {
        return ""
      }
    }
  }

  const getStatusOption = () => {
    if(adGroupState.adGroup.id === 0) {
      return options_state;
    } else if (initStatus != 1 && adGroupState.adGroup.id !== 0 && adGroupState.adGroup.placementSettingId != null 
      && placement.some(p => p.id === adGroupState.adGroup.placementSettingId && (p.displayStatus === 2 && p.adAccountIds.includes(platformAccountId) || p.displayStatus === 3 && !p.adAccountIds.includes(platformAccountId) || p.publicStatus === 2))) {
        return options_state_edit.filter(x=> x.value !== 1);
    } else {
      return options_state_edit;
    }
  }

  const menuPlacement: MenuPlacement =  adGroupId === 0? "auto": "top";
  const inputProps = {
    deliveryType: {
      id: "deliveryType",
      label: "キャンペーン種別",
      options: options_zeus_campaign_type,
    },
    pmpType: {
      id: "pmpType",
      label: "取引形式",
      options: options_zeus_pmp_type,
      inputProps: {
        readOnly: !isEditor,
      },
      readOnly: false,
      disabled: false,
    },
    billingType: {
      id: "billingType",
      label: "課金種別",
      options: options_zeus_billing_type,
      readOnly: true,
      disabled: true,
    },
    campaignId: {
      id: "campaignId",
      label: "キャンペーン",
      options: campaigns.filter(x => x.deliveryType === adGroupState.adGroup.deliveryType && (adGroupState.adGroup.deliveryType !== ZEUS_DELIVERY_TYPE.DSP || x.pmpType === adGroupState.adGroup.pmpType)),
    },
    name: {
      id: "name",
      label: "広告グループ名",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        minLength: {
          value: 1,
          message: "1文字以上を入力して下さい。"
        },
        maxLength: {
          value: 255,
          message: "255文字以内で入力して下さい。"
        },
        validate: (e: string) => {
          const errorMessage = checkInvalidCharForName(e);
          if(errorMessage) {
            return errorMessage;
          }
        },
      },
      required: true,
    },
    status: {
      id: "status",
      label: "ステータス",
      options: getStatusOption(),
      readOnly: !isEditor,
    },
    placementSettings: {
      id: "placementSettings",
      label: "プレースメント",
      isMulti: false,
      rules: {},
      options: optionPlacementSettings.filter(x => x.pmpType === adGroupState.adGroup.pmpType),
      menuPlacement: menuPlacement,
    },
    cpcLimit: {
      id: "cpcLimit",
      label: "目標CPC",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        validate: (e: number) => {
          if(e < 1) {
              return "1以上を入力して下さい。"
          }
          if(e > RESERVE_CPC_MAX) {
              return String(RESERVE_CPC_MAX) + "以内を入力して下さい。"
          }
        },
      },
      unNegative: true,
      required: adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE,
      disabled: adGroupState.isCpcLimitDisabled,
    },
    cpmLimit: {
      id: "cpmLimit",
      label: "上限CPM",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        validate: (e: number) => {
          const regExp = new RegExp('^[1-9][0-9]*$');
          if(!regExp.test(String(e))) {
            return "半角数字(先頭は0以外)を入力してください。";
          }
          if(e < 1) {
            return "1以上を入力して下さい。"
          }
          if(e > CPM_LIMIT_MAX) {
            return String(CPM_LIMIT_MAX) + "以内を入力して下さい。"
          }
        },
      },
      unNegative: true,
      required: adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP,
    },
    cpcLimitOver: {
      id: "cpcLimitOver",
      name: "cpcLimitOver",
      ariaLabel: "cpcLimitOver",
      label: "入札制御",
      disabled: adGroupState.adGroup.adCampaignId === 0 || (adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE && adGroupState.isCpcLimitDisabled === true),
    },
    affinityCategory: {
      id: "affinityCategory",
      label: "アフィニティカテゴリ",
      isMulti: true,
      rules: {},
      options: optionAffinityCategories,
      menuPlacement: menuPlacement,
    },
    customSegment: {
      id: "customSegment",
      label: "カスタムセグメント",
      isMulti: false,
      rules: {},
      options: optionCustomSegments,
      menuPlacement: menuPlacement,
    },
    retargeting: {
      id: "retargeting",
      label: "配信オーディエンス設定",
      isMulti: true,
      rules: {},
      options: optionAudiences,
      readOnly: false,
      menuPlacement: menuPlacement,
    },
  };

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <form onSubmit={onSubmit} >
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <ApolloBasicLabel label={"メニュー"} value={"パフォーマンス広告"}/>
              </Grid>
              <Grid item xs={12}>
                {adGroupState.adGroup.id === 0
                  ? <ApolloBasicSelect
                    id={inputProps.deliveryType.id}
                    label={inputProps.deliveryType.label}
                    options={inputProps.deliveryType.options}
                    value={adGroupState.adGroup.deliveryType}
                    control={control}
                    errors={adGroupState.errors.deliveryType}
                    setState={(e: any) => {
                      const deliveryType = Number(e)
                      const adCampaignId = 0;
                      const adCampaignName = "";
                      const inputData = changeInputFormData({
                        ...adGroupState.adGroup,
                        adCampaignId: adCampaignId,
                        deliveryType: deliveryType,
                        adCampaignName: adCampaignName,
                        placementSettingId: null,
                      })
                      adGroupState.setAdGroup(inputData);
                      setCampaign(initCampaign);
                    }}
                  />
                  : <ApolloBasicLabel
                    label={inputProps.deliveryType.label}
                    value={valueToOptionNull(campaign.deliveryType, inputProps.deliveryType.options)?.label ?? ""}
                  />
                }
              </Grid>
              {adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
              <Grid item xs={12}>
                {adGroupState.adGroup.id === 0
                  ? 
                  <ApolloBasicSelect
                    id={inputProps.pmpType.id}
                    label={inputProps.pmpType.label}
                    options={inputProps.pmpType.options}
                    value={adGroupState.adGroup.pmpType}
                    control={control}
                    readOnly={inputProps.pmpType.readOnly}
                    disabled={inputProps.pmpType.disabled}
                    errors={adGroupState.errors.pmpType}
                    setState={(e: any) => {
                      const adCampaignId = 0;
                      const adCampaignName = "";
                      const inputData = changeInputFormData({
                        ...adGroupState.adGroup,
                        adCampaignId: adCampaignId,
                        adCampaignName: adCampaignName,
                        placementSettingId: null,
                        pmpType: e
                      })
                      adGroupState.setAdGroup(inputData);
                      setCampaign(initCampaign);
                      
                      }
                  }
                  />
                  : <ApolloBasicLabel
                    label={inputProps.pmpType.label}
                    value={inputProps.pmpType.options.find(option => option.value == (campaign.pmpType ?? null))?.label ?? ""}
                  />
                }
              </Grid>
                       }
              <Grid item xs={12}>
                {adGroupState.adGroup.id === 0
                  ? <ApolloBasicSelect
                    id={inputProps.billingType.id}
                    label={inputProps.billingType.label}
                    options={inputProps.billingType.options}
                    value={adGroupState.adGroup.billingType}
                    control={control}
                    readOnly={inputProps.billingType.readOnly}
                    disabled={inputProps.billingType.disabled}
                    errors={adGroupState.errors.billingType}
                    setState={(e: any) => {}}
                  />
                  : <ApolloBasicLabel
                    label={inputProps.billingType.label}
                    value={valueToOptionNull(adGroupState.adGroup.billingType, inputProps.billingType.options)?.label ?? ""}
                  />
                }
              </Grid>
              <Grid item xs={12}>
                {adGroupState.adGroup.id === 0 ?
                  <ApolloBasicSelect
                    id={inputProps.campaignId.id}
                    label={inputProps.campaignId.label}
                    options={inputProps.campaignId.options}
                    value={adGroupState.adGroup.adCampaignId}
                    control={control}
                    errors={adGroupState.errors.campaignId}
                    setState={(e: any) => {
                      const deliveryType = adGroupState.adGroup.deliveryType;
                      const adCampaignId = Number(e);
                      const adCampaignName = valueToZeusCampaignNull(adCampaignId, campaigns)?.label ?? ""
                      const inputData = changeInputFormData({
                        ...adGroupState.adGroup,
                        adCampaignId: adCampaignId,
                        deliveryType: deliveryType,
                        adCampaignName: adCampaignName,
                      })
                      adGroupState.setAdGroup(inputData);
                    }}
                  />
                  : <ApolloBasicLabel label={inputProps.campaignId.label}
                                      value={`${adGroupState.adGroup.adCampaignId}_${campaign.name}`}/>
                }
              </Grid>
              <Grid item xs={12}>
                {/* 広告グループ名 */}
                <ApolloBasicTextField
                  id={inputProps.name.id}
                  label={inputProps.name.label}
                  type={inputProps.name.type}
                  value={adGroupState.adGroup.name}
                  inputProps={inputProps.name.inputProps}
                  inputRef={register(
                    inputProps.name.rules,
                  )}
                  error={errors.name}
                  required={inputProps.name.required}
                  setState={(e: any) => adGroupState.setAdGroup({
                    ...adGroupState.adGroup,
                    name: e
                  })}
                />
              </Grid>
              <Grid item xs={12}>
                {/* ステータス */}
                <ApolloBasicSelect
                  id={inputProps.status.id}
                  label={inputProps.status.label}
                  options={inputProps.status.options}
                  value={adGroupState.adGroup.status}
                  readOnly={inputProps.status.readOnly}
                  control={control}
                  errors={adGroupState.errors.status}
                  setState={(e: any) => adGroupState.setAdGroup({
                    ...adGroupState.adGroup,
                    status: e
                  })}
                />
              </Grid>
              {adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP && adGroupState.adGroup.pmpType !== ZEUS_PMP_TYPE.OPEN_AUCTION &&
              <Grid item xs={12}>
               {adGroupState.adGroup.id === 0
                  ?  
                  <ApolloBasicSelect
                        key={`placement-${adGroupState.adGroup.pmpType ?? 'none'}-${adGroupState.adGroup.placementSettingId ?? 'none'}`}
                        id={inputProps.placementSettings.id}
                        label={inputProps.placementSettings.label}
                        options={inputProps.placementSettings.options}
                        value={adGroupState.adGroup.placementSettingId}
                        isMulti={inputProps.placementSettings.isMulti}
                        control={control}
                        disabled={hasAd ? true : false}
                        errors={errors.placementSettings}
                        rules={inputProps.placementSettings.rules}
                        menuPlacement={inputProps.placementSettings.menuPlacement}
                        setState={(e: any) => {
                          adGroupState.setAdGroup({
                            ...adGroupState.adGroup,
                            placementSettingId: Number(e),
                          });
                          setLowerLimitCharge(placement.find(item => item.id === e)?.lowerLimitCharge)
                        }}
                      />
                  : <ApolloBasicLabel
                    label={inputProps.placementSettings.label}
                    style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                    value={placement.find((res) => res.id === adGroupState.adGroup.placementSettingId)
                      ? ((res) => {
                        const { placementName, displayStatus, publicStatus, adAccountIds } = res;
                        return (displayStatus === 2 && adAccountIds.includes(platformAccountId)) ||
                        (displayStatus === 3 && !adAccountIds.includes(platformAccountId)) ||
                        publicStatus === 2
                        ? `${placementName}（使用不可）`
                        : placementName;
                    })(placement.find((res) => res.id === adGroupState.adGroup.placementSettingId)!)
                  : ""
                      }
                  />
                }
              </Grid>
                       }
              <Grid item xs={12}>
                {adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE &&
                  <ApolloBasicTextField
                    id={inputProps.cpcLimit.id}
                    label={inputProps.cpcLimit.label}
                    type={inputProps.cpcLimit.type}
                    value={adGroupState.adGroup.cpcLimit || ""}
                    inputProps={inputProps.cpcLimit.inputProps}
                    inputRef={register(
                      inputProps.cpcLimit.rules,
                    )}
                    error={errors.cpcLimit}
                    required={inputProps.cpcLimit.required}
                    setState={(e: any) => adGroupState.setAdGroup({
                      ...adGroupState.adGroup,
                      cpcLimit: Number(e),
                    })}
                    unNegative={inputProps.cpcLimit.unNegative}
                    disabled={inputProps.cpcLimit.disabled}
                  />
                }
                {adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
                 <ApolloCustomTextField
                    id={inputProps.cpmLimit.id}
                    label={
                      adGroupState.adGroup.pmpType === ZEUS_PMP_TYPE.OPEN_AUCTION
                        ? inputProps.cpmLimit.label
                        : `${inputProps.cpmLimit.label}（${lowerLimitCharge ?? 1}以上の設定推奨）`
                    }
                    type={inputProps.cpmLimit.type}
                    value={adGroupState.adGroup.cpmLimit || ""}
                    inputProps={inputProps.cpmLimit.inputProps}
                    inputRef={register(
                      inputProps.cpmLimit.rules,
                    )}
                    error={errors.cpmLimit}
                    required={inputProps.cpmLimit.required}
                    setState={(e: any) => adGroupState.setAdGroup({
                      ...adGroupState.adGroup,
                      cpmLimit: Number(e),
                    })}
                    unNegative={inputProps.cpmLimit.unNegative}
                    helperText={displayWarningMessage()} // 警告メッセージを表示
                  />
                }
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  {inputProps.cpcLimitOver.label}
                </Typography>
                {adGroupState.adGroup.billingType === ZEUS_DELIVERY_TYPE.DSP && 
                  <Typography variant="caption" gutterBottom display="block" style={{whiteSpace: "normal"}}>
                    {"※入札制御で「配信機会を最大化する」を選択した場合、設定した上限CPMの超過を許容して入札します。"}
                    <br />
                    {"　「入札コントロールを優先する」を選択した場合、設定した上限CPM内で入札します。"}
                    <br />
                    {"　上限CPMはどちらの場合も、入札時に必要な要素として使用します。"}
                  </Typography>
                }
                <RadioGroup
                  aria-label={inputProps.cpcLimitOver.ariaLabel}
                  name={inputProps.cpcLimitOver.name}
                  className={classes.radioGroup}
                  value={adGroupState.cpcLimitOver}
                  onChange={(e) => {
                    adGroupState.setCpcLimitOver(stringToBoolean(e.target.value));
                  }}
                >
                  <ListItem>
                  
                  {!(adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP && !(valueToZeusCampaignNull(adGroupState.adGroup.adCampaignId, campaigns)?.autoBidding ?? true)) &&  
                    <FormControlLabel value={true} control={<Radio/>} disabled={inputProps.cpcLimitOver.disabled} label="配信機会を最大化する" />
                  }
                    <FormControlLabel value={false} control={<Radio/>} disabled={inputProps.cpcLimitOver.disabled} label="入札コントロールを優先する" />
                  </ListItem>
                </RadioGroup>          
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  ターゲティング情報
                </Typography>
                <Controller
                  name={"targetingType"}
                  control={control}
                  render={() => {
                    return (
                      <RadioGroup
                        defaultValue={adGroupState.adGroup.targetingType}
                        value={adGroupState.adGroup.targetingType}
                        onChange={(e: any) => {
                          adGroupState.setAdGroup({
                            ...adGroupState.adGroup,
                            targetingType: Number(e.target.value),
                          })
                          if (e.target.value == TARGET_TYPE.NONTARGET) {
                            setOpenDemogra(false)
                          }
                          
                        }}
                      >
                        <ListItem style={{whiteSpace: "pre-line"}}>
                          {optionTargets.map(elem => {
                            return (
                              <FormControlLabel
                                control={<Radio/>}
                                value={elem.value}
                                label={elem.label}
                                disabled={adGroupState.adGroup.adCampaignId === 0 || adGroupState.adGroup.id !== 0}
                              />
                            );
                          })}
                        </ListItem>
                      </RadioGroup>
                    );
                  }}
                />

                {adGroupState.adGroup.targetingType === TARGET_TYPE.AFFINITY
                  ? <Grid item xs={12} style={{ marginLeft: "2em", marginBottom: "1em" }}> 
                  <ApolloBasicSelect
                      id={inputProps.affinityCategory.id}
                      label={inputProps.affinityCategory.label}
                      options={inputProps.affinityCategory.options}
                      value={adGroupState.adGroup.affinityCategoryIds}
                      isMulti={inputProps.affinityCategory.isMulti}
                      control={control}
                      disabled={hasAd ? true : false}
                      errors={errors.affinityCategory}
                      rules={inputProps.affinityCategory.rules}
                      menuPlacement={inputProps.affinityCategory.menuPlacement}
                      setState={(e: any) => {
                        if (!e) {
                          adGroupState.setAdGroup({
                            ...adGroupState.adGroup,
                            affinityCategoryIds: [],
                          });
                          return;
                        }
                        if (e.length > AFFINITY_CATEGORY_MAX_ZEUS) {
                          setmsg({
                            type: "setMessage",
                            payload: {
                              ...data,
                              open: true,
                              type: "warning",
                              message: `アフィニティカテゴリは最大${AFFINITY_CATEGORY_MAX_ZEUS}個まで設定可能です。`,
                            }
                          });
                          return;
                        }
                        const setVal = e ? e.map((target: Option) => {
                          return target.value;
                        }) : [];
                        adGroupState.setAdGroup({
                          ...adGroupState.adGroup,
                          affinityCategoryIds: setVal,
                        });
                      }}
                    />
                    </Grid>
                  : adGroupState.adGroup.targetingType === TARGET_TYPE.SEGMENT
                    ? <Grid item xs={12} style={{ marginLeft: "2em", marginBottom: "1em" }}> <ApolloBasicSelect
                        id={inputProps.customSegment.id}
                        label={inputProps.customSegment.label}
                        options={inputProps.customSegment.options}
                        value={adGroupState.adGroup.customSegmentId}
                        isMulti={inputProps.customSegment.isMulti}
                        control={control}
                        disabled={hasAd ? true : false}
                        errors={errors.customSegment}
                        rules={inputProps.customSegment.rules}
                        menuPlacement={inputProps.customSegment.menuPlacement}
                        setState={(e: any) => {
                          adGroupState.setAdGroup({
                            ...adGroupState.adGroup,
                            customSegmentId: Number(e),
                          });
                        }}
                        isClearable={true}
                      />
                      </Grid>
                    : adGroupState.adGroup.targetingType === TARGET_TYPE.RETARGET
                      ? <Grid item xs={12} style={{ marginLeft: "2em", marginBottom: "1em" }}><ApolloBasicSelect
                          id={inputProps.retargeting.id}
                          label={inputProps.retargeting.label}
                          options={inputProps.retargeting.options}
                          value={adGroupState.adGroup.retargetingIds}
                          isMulti={inputProps.retargeting.isMulti}
                          control={control}
                          readOnly={inputProps.retargeting.readOnly}
                          errors={errors.retargeting}
                          rules={inputProps.retargeting.rules}
                          menuPlacement={inputProps.retargeting.menuPlacement}
                          setState={(e: any) => {
                            if (!e) {
                              adGroupState.setAdGroup({
                                ...adGroupState.adGroup,
                                retargetingIds: [],
                              });
                              return;
                            }
                            if (e.length > RETARGETING_MAX_ZEUS) {
                              setmsg({
                                type: "setMessage",
                                payload: {
                                  ...data,
                                  open: true,
                                  type: "warning",
                                  message: `配信オーディエンス設定は最大${RETARGETING_MAX_ZEUS}個まで設定可能です。`,
                                }
                              });
                              return;
                            }
                            const setVal = e ? e.map((target: Option) => {
                              return target.value;
                            }) : [];
                            adGroupState.setAdGroup({
                              ...adGroupState.adGroup,
                              retargetingIds: setVal
                            });
                          }}
                        />
                        </Grid>
                      : <></>
                }
              </Grid> 
            </Grid>
            <Grid item xs={12} style={{ marginTop: "1em" }} />
            {adGroupState.adGroup.targetingType !== TARGET_TYPE.NONTARGET &&
            <Grid item xs={12} style={{ marginLeft: "2em" }}>
                  <Typography variant="subtitle1" gutterBottom component="div">
                    デモグラ情報
                  </Typography>
                  {adGroupState.adGroup.billingType === ZEUS_DELIVERY_TYPE.PERFORMANCE && 
                    <Typography variant="caption" gutterBottom display="block" style={{whiteSpace: "normal"}}>
                      {"※キャンペーン種別がPerformance Networkの場合、デモグラフィックターゲティング指定はドコモ面でのみ有効です。"}
                      <br />
                      {"　一般メディア面の場合、デモグラフィックターゲティング指定をいただいた場合でも、"}
                      <br />
                      {"　拡張配信によりターゲティング設定したユーザー以外にも配信される場合がございます。"}
                    </Typography>
                  }
                  <IconButton aria-label="expand row" size="small" onClick={() => {
                    setOpenDemogra(state => !state)
                  }} disabled={adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET}>
                    {openDemogra ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                  </IconButton>
              </Grid>
                       }
              <Grid item xs={12} style={{ marginLeft: "2em" }}>
              {adGroupState.adGroup.targetingType !== TARGET_TYPE.NONTARGET &&
                  <Collapse in={openDemogra} timeout="auto" unmountOnExit style={{marginBottom: "5px"}}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom component="div">
                          性別
                        </Typography>
                        <FormControl>
                          <Grid container spacing={1}>
                            <Grid item>
                              <FormControlLabel 
                                control={
                                  <Checkbox 
                                    color="primary"
                                    key={demograStatus.gender1 ? "true" : "false"}
                                    defaultChecked={demograStatus.gender1}
                                    disabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET? true : false}
                                    onChange={(_, checked) => {
                                      demograStatus.setGender1(checked)
                                    }}
                                  />
                                } 
                                label="男性"                 
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel 
                                control={
                                  <Checkbox 
                                    color="primary"
                                    key={demograStatus.gender2 ? "true" : "false"}
                                    defaultChecked={demograStatus.gender2}
                                    disabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET ? true : false}
                                    onChange={(_, checked) => {
                                      demograStatus.setGender2(checked)
                                    }}
                                  />
                                } 
                                label="女性"                 
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel 
                                control={
                                  <Checkbox 
                                    color="primary"
                                    key={demograStatus.gender3 ? "true" : "false"}
                                    defaultChecked={demograStatus.gender3}
                                    disabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET ? true : false}
                                    onChange={(_, checked) => {
                                      demograStatus.setGender3(checked)
                                    }}
                                  />
                                } 
                                label="不明"                 
                              />
                            </Grid>
                          </Grid>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom component="div">
                          年齢
                        </Typography>
                        <Grid container alignItems="center">
                          <Grid item xs={12} sm={2}>
                            <Controller
                              id="ageMin"
                              name="ageMin"
                              control={control}
                              components={animatedComponents}
                              render={() => (
                                <Select
                                  options={options_age}
                                  key={demograStatus.ageMin}
                                  defaultValue={valueToOptionNull(demograStatus.ageMin, options_age)}
                                  isClearable={true}
                                  isDisabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET ? true : false}
                                  onChange={(e:any) => {
                                    demograStatus.setAgeMin(e !== null? e.value? e.value: null: null);
                                  }}
                                  rules={{
                                    min: {
                                      value: 16,
                                      message: "年齢は16歳以上を選択して下さい。"
                                    }
                                  }}
                                  />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="ageMin"
                              as={<Typography variant="caption" className={classes.errorMessage}/>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={1}>
                          <Typography variant="subtitle1" component="div" align="center">
                            〜
                          </Typography>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <Controller
                              id="ageMax"
                              name="ageMax"
                              control={control}
                              components={animatedComponents}
                              render={() => (
                                <Select
                                  options={options_age}
                                  key={demograStatus.ageMax}
                                  defaultValue={valueToOptionNull(demograStatus.ageMax, options_age)}
                                  isClearable={true}
                                  isDisabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET ? true : false}
                                  onChange={(e:any) => {
                                    demograStatus.setAgeMax(e !== null? e.value? e.value: null: null);
                                  }}
                                  rules={{
                                    min: {
                                      value: 79,
                                      message: "年齢は79歳以下を選択して下さい。"
                                    }
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="ageMax"
                              as={<Typography variant="caption" className={classes.errorMessage}/>}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom component="div">
                          居住地
                        </Typography>
                        <AreaPrefTable 
                          checkedPref={demograStatus.checkedPref} 
                          setCheckedPref={demograStatus.setCheckedPref}
                          prefRenderId={demograStatus.prefRenderId}
                          setPrefRenderId={demograStatus.setPrefRenderId}
                          checkedArea={checkedArea} // 追加
                          setCheckedArea={setCheckedArea} // 追加
                          disabled={hasAd || adGroupState.adGroup.targetingType == TARGET_TYPE.NONTARGET ? true : false}
                        />
                      </Grid>
                    </Grid>
                  </Collapse>
                       }
                </Grid>
                <Grid item xs={12} style={{ marginTop: "2em" }} />
                <Grid item xs={12} style={{ marginLeft: "2em" }}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  配信OS{adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE && "　※PC指定は、「一般メディア」のみ対象です。"}
                </Typography>
                <Grid style={{marginLeft: "1em"}}>
                  {adGroupState.adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE &&
                    <FormControlLabel control={
                      <Checkbox checked={adGroupState.osType.pc} onChange={handleChangeOsType} name={"pc"} color="primary"/>
                      } label="PC" disabled={adGroupState.adGroup.adCampaignId === 0 || adGroupState.adGroup.id !== 0}/>
                  }
                  <FormControlLabel control={
                    <Checkbox checked={adGroupState.osType.ios} onChange={handleChangeOsType} name={"ios"} color="primary"/>
                    } label="iOS" disabled={adGroupState.adGroup.adCampaignId === 0 || adGroupState.adGroup.id !== 0}/>
                  <FormControlLabel control={
                    <Checkbox checked={adGroupState.osType.android} onChange={handleChangeOsType} name={"android"} color="primary"/>
                    } label="Android" disabled={adGroupState.adGroup.adCampaignId === 0 || adGroupState.adGroup.id !== 0}/>
                </Grid>
              </Grid>
          </CardContent>
          <CardActions className={classes.cardaction}>
            <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={!isValid(adGroupId, adGroupState.adGroup) || processing.current}

              >
                {adGroupId === 0 ?
                  "作成" :
                  "更新"
                }
              </Button>
            </ApolloUserProfileAuth>
            <Button
              variant="contained"
              color="inherit"
              onClick={goBackAction}
              className={classes.button}
              disabled={processing.current}
            >
            {isEditor ? "キャンセル" : "戻る"}
            </Button>
          </CardActions>
        </Card>
      </form>
    </React.Fragment>
  )
};

export default AdGroupFormZeus;

const AreaPrefTable: React.FC<{
  checkedPref: boolean[], 
  setCheckedPref: React.Dispatch<React.SetStateAction<boolean[]>>, 
  prefRenderId: number, 
  setPrefRenderId: React.Dispatch<React.SetStateAction<number>>
  checkedArea: boolean[],  // 追加
  setCheckedArea: React.Dispatch<React.SetStateAction<boolean[]>>, // 追加
  disabled: boolean
}> = ({checkedPref, setCheckedPref, prefRenderId, setPrefRenderId, checkedArea, setCheckedArea, disabled}) => {
  const classes = apollo_useStyles();

  const clickArea = (value: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const bool = event.target.checked

    setCheckedArea(state => {
      state[value - 1] = bool
      return state
    })

    setCheckedPref(state => {
      const selectedOption = options_area_pref.filter(option => option.area.value === value)
      for (let pref of selectedOption[0].pref) {
        state[pref.value - 1] = bool
      }
      return state
    })

    setPrefRenderId(state => state + 1)
  }

  const clickPref = (value: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const bool = event.target.checked

    setCheckedPref(state => {
      state[value - 1] = bool
      return state
    })

    setCheckedArea(state => {
      for (let option_area_pref of options_area_pref) {
        let areaBool = true
        for (let option_pref of option_area_pref.pref) {
          if (!checkedPref[option_pref.value - 1]) {
            areaBool = false
            break
          }
        }
        state[option_area_pref.area.value - 1] = areaBool
      }
      return state
    })

    setPrefRenderId(state => state + 1)
  }

  return(
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="table">
        <TableHead>
          <TableRow>
            <TableCell>エリア</TableCell>
            <TableCell>都道府県</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {options_area_pref.map((option_area_pref, index) => (
            <TableRow key={index}>
              <TableCell>
                <FormControlLabel 
                  control={
                    <Checkbox
                      id={`area${option_area_pref.area.value}`}
                      name={`area${option_area_pref.area.value}`}
                      color="primary"
                      disabled={disabled}
                      onChange={event => clickArea(option_area_pref.area.value, event)}
                      key={prefRenderId}
                      defaultChecked={
                        checkedArea[option_area_pref.area.value - 1]
                      }
                    />
                  } 
                  label={`${option_area_pref.area.label}`}
                />      
              </TableCell>
              <TableCell>
                {option_area_pref.pref.map((option_pref, index) => (
                  <FormControlLabel 
                    control={
                      <Checkbox
                        id={`pref${option_pref.value}`}
                        name={`pref${option_pref.value}`}
                        color="primary"
                        disabled={disabled}
                        onChange={event => clickPref(option_pref.value, event)}
                        key={prefRenderId}
                        defaultChecked={
                          checkedPref[option_pref.value - 1]
                        }
                      />
                    } 
                    label={`${option_pref.label}`}
                    key={index}
                  />     
                ))}
              </TableCell>
            </TableRow>
           ))}
        </TableBody>
      </Table>
    </TableContainer>
  )

}
